/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
import { Box } from '@mui/material';

const preStyle = {
  bgcolor: 'grey.50',
  borderRadius: 1,
  fontFamily: 'monospace',
  fontSize: 11,
  margin: 0,
  maxHeight: 120,
  overflow: 'auto',
  padding: 1,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
} as const;

export const PreBox: React.FC<{ data: unknown }> = ({ data }) => {
  return (
    <Box component="pre" sx={preStyle}>
      {JSON.stringify(data, null, 2)}
    </Box>
  );
};
